<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Patient List</a>
  </div>-->

  <div class="row top-link" *ngIf="Showivfbench">
    <div class="col-md-3" [hidden]="!HasAccess2('IVF Workbench')">
      <div class="card  margin-top-20px">
        <div class="card-header wh-header padding-bottom-6px padding-left-13px">
          <div class="row">
            <div class="col-md-12">
              Work Bench
            </div>
            <!--<div class="col-md-8 padding-right-0px">

            <div class="col-md-3 float-right padding-left-0px padding-right-0px">
              <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
            </div>
            <div class="offset-md-7 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
              <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
            </div>
          </div>-->
          </div>

        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">

          <div class=" margin-left-0px margin-right-0px  margin-bottom-sm-0px">
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="display(l)" *ngFor="let l of CurrentIvfworkbenchController">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">
                      <!--<div class="row">
              <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
            </div>-->

                      <label class="margin-top-4px  margin-bottom-3px">{{l.NumberCount}}</label>


                    </div>

                    <!--<label class=" margin-left-auto margin-right-auto margin-bottom-0px font-size-20px"></label>-->
                  </div>
                  <div class="col-md-9 col-9  padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-18px">{{l.Name}}</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 offset-2 col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displayet()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-18px">Embryo Transfer</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12 padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displaysa()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9  padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Semen Analysis</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displaypt()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Pregnancy Tracker</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displaycp()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Cryo Preservation</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <!--<div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayscans()">


    <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
      <div class="row">
        <div class="col-md-1 col-1 text-align-center padding-left-0px">
          <div class="col-md-1">
            <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


              <label class="margin-top-4px  margin-bottom-3px">10</label>


            </div>
          </div>

        </div>
        <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
          <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Scans</label>
        </div>


      </div>

      <div class="row margin-top-10">
        <div class="offset-md-2 col-md-3 col-3 offset-2">
          <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div class=""><label class="margin-top-4px">Completed</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


          </div>
        </div>
        <div class="col-md-3 col-3">
          <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div><label class="margin-top-4px">Pending</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


          </div>
        </div>
        <div class="col-md-3 col-3">
          <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div><label class="margin-top-4px">No Show</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


          </div>
        </div>

      </div>
    </div>


  </div>
  <div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displaypickup()">


    <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
      <div class="row">
        <div class="col-md-1 col-1 text-align-center padding-left-0px">
          <div class="col-md-1">
            <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


              <label class="margin-top-4px  margin-bottom-3px">10</label>


            </div>
          </div>

        </div>
        <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
          <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Pickup</label>
        </div>


      </div>

      <div class="row margin-top-10">
        <div class="offset-md-2 col-md-3 offset-2 col-3">
          <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div class=""><label class="margin-top-4px">Completed</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


          </div>
        </div>
        <div class="col-md-3 col-3">
          <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div><label class="margin-top-4px">Pending</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


          </div>
        </div>
        <div class="col-md-3 col-3">
          <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
            <div><label class="margin-top-4px">No Show</label></div>

            <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


          </div>
        </div>

      </div>
    </div>


  </div>-->



          </div>
          <!--<div class="row margin-left-0px margin-right-0px margin-bottom-lg-15px margin-bottom-sm-0px">
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displayoqa()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Oocyte Quality</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displaysa()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Semen Analysis</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayinsemination()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Insemination</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>



        </div>
        <div class="row margin-left-0px margin-right-0px ">
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displaygrading()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Grading</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 offset-2 col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayfreezing()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-7 col-7 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Freezing</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>

          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayet()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Transfer</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>




        </div>-->
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card  margin-top-20px">
        <div class="card-header wh-header padding-bottom-6px padding-left-13px">
          <div class="row">
            <div class="col-md-12">
              Followup
            </div>
            <!--<div class="col-md-8 padding-right-0px">

            <div class="col-md-3 float-right padding-left-0px padding-right-0px">
              <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
            </div>
            <div class="offset-md-7 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
              <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
            </div>
          </div>-->
          </div>

        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">

          <div class=" margin-left-0px margin-right-0px  margin-bottom-sm-0px">
         
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displayCounselling()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-18px"> Counselling Register</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12 padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displayActivity()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">&#63;</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9  padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-18px"> Daily Work Book</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <!--<div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayscans()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Scans</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 col-3 offset-2">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displaypickup()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Pickup</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>-->



          </div>
          <!--<div class="row margin-left-0px margin-right-0px margin-bottom-lg-15px margin-bottom-sm-0px">
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displayoqa()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Oocyte Quality</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displaysa()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Semen Analysis</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayinsemination()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Insemination</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>



        </div>
        <div class="row margin-left-0px margin-right-0px ">
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displaygrading()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Grading</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 offset-2 col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>
          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayfreezing()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-7 col-7 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Freezing</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>

          <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayet()">


            <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
              <div class="row">
                <div class="col-md-1 col-1 text-align-center padding-left-0px">
                  <div class="col-md-1">
                    <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">10</label>


                    </div>
                  </div>

                </div>
                <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                  <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Transfer</label>
                </div>


              </div>

              <div class="row margin-top-10">
                <div class="offset-md-2 col-md-3 offset-2 col-3">
                  <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div class=""><label class="margin-top-4px">Completed</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">Pending</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                  </div>
                </div>
                <div class="col-md-3 col-3">
                  <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                    <div><label class="margin-top-4px">No Show</label></div>

                    <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                  </div>
                </div>

              </div>
            </div>


          </div>




        </div>-->
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="row top-link2 overscrollbehavior">
    <div class="col-md-3 col-12">
      <div class="card  margin-top-20px">
        <div class="card-header wh-header padding-bottom-6px padding-left-13px">
          <div class="row">
            <div class="col-md-12 col-7">
              Work Bench
            </div>
            <div class="col-5  padding-right-0px" hidden>
              <a class="nav-link font-size-16px float-right padding-top-0px padding-bottom-0px" (click)="displaydashboard()"
                 title="Dashboard">
                <i class="fas fa-home"></i>


              </a>

            </div>
            <!--<div class="col-md-8 padding-right-0px">

              <div class="col-md-3 float-right padding-left-0px padding-right-0px">
                <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
              </div>
              <div class="offset-md-7 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
                <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
              </div>
            </div>-->
          </div>

        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">

          <div class=" margin-left-0px margin-right-0px  margin-bottom-sm-0px">
            <!--<div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="display(l)" *ngFor="let l of CurrentIvfworkbenchController">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-1 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">{{l.NumberCount}}</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9  padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">{{l.Name}}</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 offset-2 col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>-->
            <div class="col-md-12 col-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displayscans()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-2 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">0</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Scans</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displaypickupready()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-2 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">0</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Ready for Pickup</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displaypickup()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-2 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">0</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">PickUps</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-12  padding-right-sm-15px  margin-bottom-mobile-10px" (click)="displayet()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-3 col-2 text-align-center padding-left-0px">

                    <div class="badge badge-scan-data margin-left-auto padding-top-0px padding-bottom-0px border-radius-0px">


                      <label class="margin-top-4px  margin-bottom-3px">0</label>


                    </div>


                  </div>
                  <div class="col-md-9 col-9 padding-right-0px padding-left-0px text-align-left white-space-normal">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Transfer</label>
                  </div>


                </div>

                <div class="row margin-top-10" hidden>
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>

            <!--<div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayscans()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Scans</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 col-3 offset-2">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-3  padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displaypickup()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Follicular Pickup</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>-->



          </div>
          <!--<div class="row margin-left-0px margin-right-0px margin-bottom-lg-15px margin-bottom-sm-0px">
            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displayoqa()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Oocyte Quality</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displaysa()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 col-9 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Semen Analysis</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayinsemination()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-9 col-9 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Insemination</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>



          </div>
          <div class="row margin-left-0px margin-right-0px ">
            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-left-11p margin-bottom-mobile-10px" (click)="displaygrading()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Grading</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 offset-2 col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-bottom-mobile-10px" (click)="displayfreezing()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-7 col-7 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Freezing</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>

            <div class="col-md-3 padding-right-lg-0px padding-right-sm-15px margin-right-11p margin-bottom-mobile-10px" (click)="displayet()">


              <div class="badge badge-scans-new margin-left-lg-10px margin-left-sm-0px nav-link-hand ">
                <div class="row">
                  <div class="col-md-1 col-1 text-align-center padding-left-0px">
                    <div class="col-md-1">
                      <div class="badge badge-scan-data margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">


                        <label class="margin-top-4px  margin-bottom-3px">10</label>


                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 col-10 text-align-center padding-right-0px padding-left-0px">
                    <label class="margin-bottom-0px margin-top-4px  font-size-20px">Embryo Transfer</label>
                  </div>


                </div>

                <div class="row margin-top-10">
                  <div class="offset-md-2 col-md-3 offset-2 col-3">
                    <div class="badge badge-scan-data2 background-badge-completed margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div class=""><label class="margin-top-4px">Completed</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-pending margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">Pending</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">4</label>


                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="badge badge-scan-data2 background-badge-notshow margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                      <div><label class="margin-top-4px">No Show</label></div>

                      <label class="margin-top-4px font-size-15px margin-bottom-3px">2</label>


                    </div>
                  </div>

                </div>
              </div>


            </div>




          </div>-->
        </div>
      </div>
    </div>

    <div class="col-md-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!--<div class="col-md-12">

  <scansoftheday *ngIf="ScanDetails"></scansoftheday>
</div>
<div class="col-md-12">

  <ivfpickupedit *ngIf="PickUpDetails"></ivfpickupedit>
</div>
<div class="col-md-12">

  <ivfetedit *ngIf="ETDetails"></ivfetedit>
</div>
<div class="col-md-12">

  <ivfsemananedit *ngIf="SADetails"></ivfsemananedit>
</div>
<div class="col-md-12">

  <ivfinseminationedit *ngIf="InseminationDetails"></ivfinseminationedit>
</div>
<div class="col-md-12">

  <ivfoqaedit *ngIf="OQADetails"></ivfoqaedit>
</div>
<div class="col-md-12">

  <ivfgradingedit *ngIf="GradingDetails"></ivfgradingedit>
</div>
<div class="col-md-12">

  <app-freezing *ngIf="FreezingDetails"></app-freezing>
</div>-->
